"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImageSizeFromUrl = void 0;
var get_image_size_from_img_element_1 = require("./get-image-size-from-img-element");
var getImageSizeFromUrl = function (url) {
    return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () { return resolve((0, get_image_size_from_img_element_1.getImageSizeFromImageElement)(img)); };
        img.onerror = reject;
        img.src = url;
    });
};
exports.getImageSizeFromUrl = getImageSizeFromUrl;
